import {z} from "zod";

export const referenceRemarksSchema = z.object({
    remarks: z
        .string()
        .max(512, {
            message: 'Maximal 512 Zeichen erlaubt',
        })
        .optional(),
    reference: z
        .string()
        .max(64, {
            message: 'Maximal 64 Zeichen erlaubt',
        })
        .optional(),
});
